import configMap from "src/shared/constants/configMap";
import _BRANCH from "./constants/_BRANCH";

export const BRANCH = _BRANCH;

export const baseEnv: "dev" | "staging" | "dogfooding" | "prod" | "missing" = (() => {
	if (BRANCH === "dev") return "dev";
	if (BRANCH === "staging") return "staging";
	if (BRANCH === "dogfooding") return "dogfooding";
	if (BRANCH === "prod") return "prod";
	if (__DEV__) return "dev";
	return "missing";
})();
export const curEnv: "dev" | "staging" | "dogfooding" | "prod" = (() => {
	switch (baseEnv) {
		case "missing":
			return "prod";
		default:
			return baseEnv;
	}
})();
export const curBackend: "dev" | "staging" | "prod" = (() => {
	switch (baseEnv) {
		case "missing":
			return "prod";
		case "dogfooding":
			return "prod";
		default:
			return baseEnv;
	}
})();

export const isDev = curEnv === "dev";
export const notProd = curEnv === "dev" || curEnv === "staging";
export const isProd = curEnv === "dogfooding" || curEnv === "prod";
const config = configMap[curBackend];
export const AMPLITUDE_KEY = config.amplitudeConfig.key;

export default config;
